export class UserContextError extends Error {
    constructor(message) {
        super(message);
    }
}
